import { render, staticRenderFns } from "./modularChild10.vue?vue&type=template&id=c2a34b32&scoped=true"
import script from "./modularChild10.vue?vue&type=script&lang=js"
export * from "./modularChild10.vue?vue&type=script&lang=js"
import style0 from "./modularChild10.vue?vue&type=style&index=0&id=c2a34b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a34b32",
  null
  
)

export default component.exports